<template>
  <v-col cols="12">
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Tags</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddTagGroup">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels>
      <v-expansion-panel v-for="(tagGroup, index) in tagGroups" :key="index">
        <v-expansion-panel-header>
          <template v-slot:default="{ open }">
            <v-fade-transition leave-absolute>
              <v-row no-gutters>
                <v-col cols="3">
                  <v-chip v-if="open" key="0" small color="primary"> {{ tagGroup.id }} </v-chip>
                  <v-chip v-else key="1" small color="primary"> {{ tagGroup.id }} </v-chip>
                </v-col>

                <v-col cols="8">
                  <v-chip class="ma-1" v-for="chipTags in tagGroup.tags" :key="chipTags.id" small color="primary">
                    {{ chipTags.id }}
                  </v-chip>
                </v-col>

                <v-spacer> </v-spacer>
                <v-col cols="1">
                  <v-btn icon>
                    <v-icon @click="onDeleteTagGroup(index)">mdi-close-thick</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p></p>

          <v-combobox
            v-model="tagGroup.id"
            :items="tagGroupSelection"
            item-value="id"
            item-text="id"
            chips
            @change="setTagGroupSelection(tagGroup.id, index)"
          ></v-combobox>
          <p></p>
          <v-combobox
            v-model="tagGroup.tags"
            :items="getTagGroupSelection(tagGroup.id)"
            item-value="id"
            item-text="id"
            multiple
            chips
          ></v-combobox>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
  export default {
    name: 'EditTagsPanel',
    props: {
      tagGroups: Array,
    },

    data: () => ({
      tagGroupSelection: ['ORG', 'COUNTRY', 'DICIPLINE', 'DISTANCE'],

      tagGroupSelectionTags: [{ id: 'DFS' }, { id: 'CMP' }, { id: 'ISSF' }, { id: 'NSF' }, { id: 'NJFF' }, { id: 'FFTir' }],

      //Hardcoded example tags. These lists are waiting to be filled with database fetched data(Possibly).
      orgTags: [{ id: 'DFS' }, { id: 'CMP' }, { id: 'ISSF' }, { id: 'NSF' }, { id: 'NJFF' }],
      countryTags: [{ id: 'NO' }, { id: 'EN' }],
      diciplineTags: [{ id: 'FCLASS' }, { id: 'TR' }, { id: 'RIFLE' }, { id: 'PISTOL' }],
      distanceTags: [{ id: '50m' }, { id: '100m' }, { id: '200m' }, { id: '300m' }],
      //End of harcoded lists
    }),

    methods: {
      getTagGroupSelection(tagGroup) {
        switch (tagGroup) {
          case 'ORG':
            return this.orgTags;

          case 'COUNTRY':
            return this.countryTags;

          case 'DICIPLINE':
            return this.diciplineTags;

          case 'DISTANCE':
            return this.distanceTags;
          default:
            return this.orgTags;
        }
      },
      setTagGroupSelection(tagGroup, index) {
        if (index != null) this.tagGroups[index].tags = [];
        switch (tagGroup) {
          case 'ORG':
            this.tagGroupSelectionTags = this.orgTags;
            break;
          case 'COUNTRY':
            this.tagGroupSelectionTags = this.countryTags;
            break;
          case 'DICIPLINE':
            this.tagGroupSelectionTags = this.diciplineTags;
            break;
          case 'DISTANCE':
            this.tagGroupSelectionTags = this.distanceTags;
            break;
        }
      },
      onAddTagGroup() {
        this.tagGroups.push({
          id: '',
          tags: [],
        });
      },
      onDeleteTagGroup(id) {
        this.$emit('onDeleteTagGroup', id);
      },
    },
  };
</script>
